import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetCashtagProfileRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetCashtagProfileResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getCashtagProfile = (request: GetCashtagProfileRequest, options?: CashRequestOptions) =>
  post<GetCashtagProfileRequest, GetCashtagProfileResponse>('/2.0/cash/get-cashtag-profile', request, {
    ...options,
    rejectOnError: true,
  })
